import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    setMensagem: ["payload"],
    setErro: ["payload"]
});

const INITIAL_STATE = {
    mensagem: "",
    exibirMensagem: false,
    erro: "",
    exibirErro: ""
};

const setMensagem = (state = INITIAL_STATE, action) => {
    const { mensagem, mostrar } = action.payload;

    return {
        ...state,
        mensagem: mensagem ? mensagem : "",
        exibirMensagem: typeof mostrar === "boolean" ? mostrar : true
    };
};

const setErro = (state = INITIAL_STATE, action) => {
    const { mensagem, mostrar } = action.payload;

    return {
        ...state,
        erro: mensagem ? mensagem : "",
        exibirErro: typeof mostrar === "boolean" ? mostrar : true
    };
};

export default createReducer(INITIAL_STATE, {
    [Types.SET_MENSAGEM]: setMensagem,
    [Types.SET_ERRO]: setErro
});
